
export const flagDemographicsIncorrect = (state, {status, error}) => {
    state.applicant.demographic.flagStatus = status;
    state.applicant.demographic.error = error;
};